import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/App.css";
import {
  HashRouter,
  Route,
  Switch,
  Redirect,
  BrowserRouter,
} from "react-router-dom";
import AuthLayout from "./layouts/auth";
import AdminLayout from "./layouts/admin";
import { createStore, applyMiddleware } from "redux";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./RootReducer";
import { overviewSaga } from "./views/admin/default/saga";
import { campaignDetailsSaga } from "./views/admin/campaign_create/saga";
import { cpaCampaignDetailsSaga } from "./views/admin/cpaCampaignCreate/saga";
import theme from "./theme/theme";
import { authenticationSaga } from "./listener/signin/saga";
import { eventsSaga } from "./views/admin/events/saga";
import { roasSaga } from "./views/admin/roas/saga";
import { retentionSaga } from "views/admin/retention/saga";
import GlobalLoading from "components/loading/GlobalLoading";

const sagaMiddleware = createSagaMiddleware();
//@ts-ignore
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(overviewSaga);
sagaMiddleware.run(eventsSaga);
sagaMiddleware.run(roasSaga);
sagaMiddleware.run(retentionSaga);
sagaMiddleware.run(campaignDetailsSaga);
sagaMiddleware.run(cpaCampaignDetailsSaga);
sagaMiddleware.run(authenticationSaga);

ReactDOM.render(
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        <BrowserRouter>
          <GlobalLoading />
          <Switch>
            {/*<Route path={`/login`} component={AuthLayout} />*/}
            <Route path={`/`} component={AdminLayout} />
            <Redirect from="/" to="/ua" />
          </Switch>
        </BrowserRouter>
      </React.StrictMode>
    </ChakraProvider>
  </Provider>,
  document.getElementById("root")
);
